import { Directive } from '@angular/core';
import {
  ListView,
  ListViewProviderDirective,
  ViewProviderDirective
} from '@ntap/core';
import { Observable, map } from 'rxjs';
import { ParentListViewProvider } from '../pretraga-kataloga/providers/parent-list-view.provider';
import { TableListGridProviderDirective } from '../table-list-grid/directives/table-list-grid-provider.directive';

@Directive({
  selector: '[appOdabirPovezanogMjestaProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: OdabirPovezanogMjestaProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: OdabirPovezanogMjestaProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: OdabirPovezanogMjestaProviderDirective
    },
    {
      provide: TableListGridProviderDirective,
      useExisting: OdabirPovezanogMjestaProviderDirective
    }
  ]
})
export class OdabirPovezanogMjestaProviderDirective extends ListViewProviderDirective<ListView> {
  override get view$(): Observable<ListView> {
    return super.view$.pipe(
      map((view: any) => {
        view.actions = view.actions.filter(
          (a: any) => a.name === 'openMjesto' || a.name === 'multiselect'
        );
        return view;
      })
    );
  }
}
